import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthenticationService} from '../../_auth/authentication.service';

/**
 * Persistent banner shown whenever the active session is impersonating another user. Always visible (unlike the
 * auto-hiding alert banner) so the operator can never forget they are acting as someone else, and offers a
 * one-click "stop impersonating" that restores the platform-owner session.
 */
@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="impersonation-banner" *ngIf="auth.isImpersonating">
      <span class="impersonation-banner__text">
        ⚠️ Impersonation active — you are working as
        <strong>{{ auth.userValue?.name }}</strong>
        <ng-container *ngIf="auth.userValue?.impersonatedByName">
          (started by {{ auth.userValue?.impersonatedByName }})
        </ng-container>
      </span>
      <button type="button" class="impersonation-banner__stop" (click)="stop()" [disabled]="working">
        {{ working ? 'Stopping…' : 'Stop impersonating' }}
      </button>
    </div>
  `,
  styles: [`
    /* Docked at the bottom (full width) so it never overlays the fixed top navbar; the account switcher is
       hidden during impersonation, so the bottom strip is free. */
    .impersonation-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      padding: 0.5rem 1rem;
      background: #b00020;
      color: #fff;
      font-weight: 600;
      box-shadow: 0 -2px 6px rgba(0, 0, 0, .25);
    }

    .impersonation-banner__stop {
      background: #fff;
      color: #b00020;
      border: none;
      border-radius: 4px;
      padding: 0.25rem 0.75rem;
      font-weight: 700;
      cursor: pointer;
    }

    .impersonation-banner__stop:disabled {
      opacity: .6;
      cursor: default;
    }
  `]
})
export class ImpersonationBannerComponent {
  working = false;

  constructor(public auth: AuthenticationService) {
  }

  stop() {
    if (this.working) return;
    this.working = true;
    this.auth.stopImpersonation().subscribe({
      next: () => window.open('/', '_self'),
      error: () => (this.working = false)
    });
  }
}
